// extracted by mini-css-extract-plugin
module.exports = {"link":"MediaLinkTheme_link__2iUAV"};